import Stack from '@mui/material/Stack';

import { Text } from '@knowz/knowz-ui';
import StyledBox from '@webclient/components/user-authentication/sections/steps/components/word-divider/styles';

export default function WordDivider({ text }: { text: string }) {
  return (
    <Stack
      gap={2}
      direction="row"
      alignItems="center"
    >
      <StyledBox />

      <Text
        sx={{ textTransform: 'uppercase' }}
        variant="textSm"
        weight="medium"
        align="center"
        color="text.tertiary"
      >
        {text}
      </Text>

      <StyledBox />
    </Stack>
  );
}
